import { useMemo } from "react";
import { aggFuncsDefault } from "../aggFuncs/aggFuncsDefault";

export const useAggFuncs = (groupByCategory, editing) => {
  return useMemo(() => aggFuncsDefault(), []);
};

/**
   const aggFuncs = useAggFuncs();
*/
